let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
items && items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", !0),
      item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open")
      }),
      item.addEventListener("mouseleave", () => {
          item.removeAttribute("open")
      })
    })
  }
);

// let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;

// if (items) {
//   items.forEach(item => {
//     // Open dropdown on hover
//     item.addEventListener("mouseover", () => {
//       item.setAttribute("open", true);
//     });

//     // Close dropdown on mouse leave
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });

//     // Keep the default click functionality to navigate to the collection
//     // If there’s an <a> tag within <details> for navigation, this will ensure that it works as expected
//     item.querySelector("summary").addEventListener("click", (e) => {
//       const link = item.querySelector("summary span");
//       if (link) {
//         // Optional: Close other open menus before navigating if needed
//         items.forEach(i => i.removeAttribute("open"));
        
//         // Navigate to the collection link
//         window.location.href = link.href;
//       }
//     });
//   });
// }

// faq accordian js
$(document).ready(function() {
  function faqAccordion() {
    let $accoHeadings = $('.faq-accordian .acc-block-wrap .acco-head');
    console.log("$accoHeadings :: ",$accoHeadings);
    $accoHeadings.off('click').on('click', function() {
      let $selectHeading = $(this);
      let $selectedContent = $selectHeading.next();

      $accoHeadings.not($selectHeading).each(function() {
        let $otherContent = $(this).next(); 
        if ($otherContent.is(':visible')) {
          $otherContent.slideUp();
          $(this).removeClass('active');
        }
      });
      $selectedContent.slideToggle();
      $selectHeading.toggleClass('active');
    });
  }
  faqAccordion();
  $(window).resize(function() {
  });
});

// product page tab
var tabTitles = document.querySelectorAll(".product-tab-wrapper .tab-title");
tabTitles && tabTitles.forEach(function(tabTitle, index) {
    tabTitle.addEventListener("click", function() {
        var swiperElement = tabTitle.closest(".swiper")
          , swiperInstance = swiperElement.swiper;
        console.log("Swiper", swiperInstance),
        console.log("Index", index),
        swiperInstance.slideTo(index),
        tabTitles.forEach(function(tabTitle2) {
            tabTitle2.classList.remove("active"),
            tabTitle2.classList.remove("swiper-slide-active")
        }),
        tabTitle.classList.add("active"),
        tabTitle.classList.add("swiper-slide-active");
        var tab = tabTitle.getAttribute("data-tab-title")
          , tabWrappers = document.querySelectorAll(".product-tab-contents .tab-content");
        tabWrappers && tabWrappers.forEach(function(tabwrapper) {
            tabwrapper.classList.remove("active");
            var tabContent = tabwrapper.getAttribute("data-tab");
            tab == tabContent && tabwrapper.classList.add("active")
        })
    })
});


// var Product_swiper = new Swiper(".custom_slider_pdp[custom_product_slider]",{
//     slidesPerView:1,
//     spaceBetween:10,
//     navigation:{
//       nextEl:".swiper-button-next",
//       prevEl:".swiper-button-prev"
//     },
//     keyboard:{
//       enabled:true,
//       onlyInViewport:true
//     },
//     allowTouchMove: true,
//     speed:500,
//     thumbs:{
//       swiper:{
//         slidesPerView:5,
//         el:".swiprt_thumbnail_slider",
//         slidesPerView:1,
//         spaceBetween:15,
//         slideThumbActiveClass: "swiper-slide-thumb-active",
//         // navigation:{
//         //     nextEl:".swiper-button-next.thumb",
//         //     prevEl:".swiper-button-prev.thumb"
//         // },
//         breakpoints:{
//           0: {
//                slidesPerView:4,
//             },
//          1025: {
//             slidesPerView: 5,
//            direction: "vertical"
//           }
//         }
//       }
//     }
// });